import { GetOrderWalletPaidAmountDocument } from "@/core/api/graphql/types";
import { graphqlClient } from "../../../client";
import type { GetOrderWalletPaidAmountQueryVariables } from "@/core/api/graphql/types";

export async function getOrderWalletPaidAmount(payload: GetOrderWalletPaidAmountQueryVariables): Promise<number> {
  const { data } = await graphqlClient.query({
    query: GetOrderWalletPaidAmountDocument,
    variables: payload,
    fetchPolicy: "network-only",
  });

  return data.orderWalletPaidAmount ?? 0;
}
